export var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy90dXBsZS50cyJdLCJuYW1lcyI6WyJ0dXBsZSIsImFyZ3MiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sSUFBTUEsS0FBSyxHQUFHLFNBQVJBLEtBQVE7QUFBQSxvQ0FBd0JDLElBQXhCO0FBQXdCQSxJQUFBQSxJQUF4QjtBQUFBOztBQUFBLFNBQW9DQSxJQUFwQztBQUFBLENBQWQiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgdHVwbGUgPSA8VCBleHRlbmRzIHN0cmluZ1tdPiguLi5hcmdzOiBUKSA9PiBhcmdzO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/tuple.js
// module id = 1748
// module chunks = 118